"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.idle = void 0;
var _idleSessionTimeout = require("idle-session-timeout");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var idle = function idle(timer, onTimeOut) {
  var idleTimer = new _idleSessionTimeout.IdleSessionTimeout(timer);
  if (_lodash.default.isFunction(onTimeOut)) {
    idleTimer.onTimeOut = onTimeOut;
  }
  return idleTimer;
};
exports.idle = idle;